
import click_drag from "./click_drag";
import drag_timeline from "./drag_timeline";
import fullscreen from "./fullscreen";
import * as keyboard_navigation from "./keyboard_navigation";
import * as marker from "./marker";
import * as multiselect from "./multiselect";
import quick_info from "./quick_info";
import tooltip from "./tooltip";
import undo from "./undo";

export default {
	click_drag,
	drag_timeline,
	fullscreen,
	keyboard_navigation,
	quick_info,
	tooltip,
	undo,
	marker,
	multiselect,
};